// @ts-nocheck
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';

// import { ControllerValidationBarrament } from '../input-text/controller-validation-barrament';
// import { InputFieldErrorDirective } from '../input-text/error-overlay/error-overlay.directive';

@Component({
  selector: 'lbca-input-checkbox',
  templateUrl: './input-checkbox.component.html',
  styleUrl: './input-checkbox.component.scss',
  imports: [IconComponent],
})
export class InputCheckboxComponent {
  public labelValue: string = '';
  public helperTextValue: string = '';
  public isRequired: boolean = false;
  public isDisabled: boolean = false;
  public inlineFields: boolean = false;

  private option!: any;
  public options: any[] = [];

  hasError: boolean = false;
  isValid: boolean = false;

  isTouched: boolean = false;
  hasValue: boolean = false;

  @Output() inputValueChange = new EventEmitter();
  @Output() change = new EventEmitter();

  @Output('errorState')
  errorStateEmmiter = new EventEmitter();

  @Output('validState')
  validStateEmmiter = new EventEmitter();

  @Output()
  filledState = new EventEmitter();

  // public controllerBarr = new ControllerValidationBarrament();

  // @HostBinding('attr.errorOverlay') errorOverlay = new InputFieldErrorDirective(
  //   this.overlay, this.elementRef, this.controllerBarr);

  public errorposition!: string;

  valueSelected: any[] = [];
  valueInput: any[] = [];

  @Input()
  set inline(val) {
    this.inlineFields = val;
  }

  @Input()
  set overlayposition(value) {
    this.errorposition = value;
  }

  @Input('options')
  set optionsList(val) {
    this.option = val;
    this.options = val;
  }

  @Input()
  set disabled(disabled: boolean) {
    this.isDisabled = disabled;
  }

  @Input()
  set label(value: string) {
    this.labelValue = value;
  }

  @Input()
  set require(status: boolean) {
    this.isRequired = status;
  }

  @Input()
  set value(val: Array<any>) {
    if (val) {
      const stringded = val?.map((i) => i.toString()) || [];
      this.checkValue(stringded);
      if (!this.hasValue) this.isTouched = false;
    }
  }

  @Output('changeLabelValue')
  changeLabelValueEmmiter = new EventEmitter();

  @Output('blurValue')
  blurValueEmmiter = new EventEmitter();

  @Output('focusState')
  focusStateEmmiter = new EventEmitter();

  @Input('error')
  set err(error) {
    if (error) {
      // this.controllerBarr.setProperty('generic-field', "dataError", error);
    }
  }

  @Input()
  set checkValidation(validCheck) {
    if (validCheck) {
      // ! teste
      if (this.isRequired) {
        // await value initialization
        setTimeout(() => {
          // this.controllerBarr.setProperty('generic-field', 'requiredError', !this.hasValue);
        }, 100);
      }
    }
  }

  mouseenter() {
    // this.controllerBarr.setProperty('generic-field', 'focus', true);
  }

  mouseleave() {
    // this.controllerBarr.setProperty('generic-field', 'focus', false);
  }

  // constructor(public overlay: Overlay, public elementRef:ElementRef){

  //   this.controllerBarr.changes.subscribe(
  //     (change) => {
  //       if(change.who === 'generic-field') return;
  //       if (change.who === 'error'){
  //         if (change.key === 'masterStatus') this.analyseMasterStatus(change.value);
  //       }

  //     }
  //   )

  //  }

  private analyseMasterStatus(masterStatus) {
    if (masterStatus === 'err') {
      this.isValid = false;
      this.hasError = true;
    } else if (masterStatus === 'ok') {
      this.isValid = true;
      this.hasError = false;
    } else {
      this.isValid = false;
      this.hasError = false;
    }

    this.errorStateEmmiter.emit(this.hasError);
    this.validStateEmmiter.emit(this.isValid);
  }

  public selectOption($event, option) {
    if (!this.verifyCheckedItem(option)) {
      this.valueInput.push(option?.label);
      this.valueSelected.push(option?.id as any); // evitando erros com retorno booleanos
    } else {
      const index = this.valueSelected.indexOf(option.id);
      if (index !== -1) {
        this.valueSelected.splice(index, 1);
      }
    }
    this.checkValue(this.valueSelected);
    this.blurValueEmmiter.emit(this.valueSelected);
    this.changeLabelValueEmmiter.emit(option.label);

    this.focusStateEmmiter.emit(false);
  }

  public verifyCheckedItem(option) {
    return this.valueSelected.filter((value) => value === option.id).length > 0;
  }

  private checkValue(value) {
    if (value.length > 0) {
      this.valueSelected = value;
      this.isTouched = true;
      this.hasValue = true;
    } else {
      this.hasValue = false;
    }

    this.filledState.emit(this.hasValue);

    setTimeout(() => {
      // this.controllerBarr.setProperty('generic-field', 'changed', this.hasValue);
    }, 5);
  }
}
